<!-- Director Mode - FikoDialogCore icinde gosterilir -->
<div class="director-panel" [class.kayit-aktif]="kayitYapiliyor">

    <!-- Üst Kontroller -->
    <div class="kontrol-bar">
        <button class="ui icon mini button" [class.aktif]="aktif" (click)="toggle()"
            [title]="aktif ? 'Director Mode Durdur' : 'Director Mode Başlat'">
            <i [class]="aktif ? 'pause icon' : 'film icon'"></i>
        </button>
        <button class="ui icon mini button" [class.kayit]="kayitYapiliyor"
            (click)="kayitYapiliyor ? kayitDurdur() : kayitBaslat()"
            [title]="kayitYapiliyor ? 'Kaydı Durdur' : 'Kayda Başla'">
            <i [class]="kayitYapiliyor ? 'stop icon' : 'circle icon'"></i>
        </button>
        <span class="kayit-suresi" *ngIf="kayitYapiliyor">
            <span class="rec-dot"></span>
            {{sureFormatla(kayitSuresi)}}
        </span>
        <span class="durum-text" *ngIf="aktif && !kayitYapiliyor">
            {{KAMERA_ACILARI[suankiAci].isim}}
        </span>
    </div>

    <!-- Kamera Açıları -->
    <div class="section-row">
        <div class="section-label">KAMERA</div>
        <div class="aci-grid">
            <button *ngFor="let aci of aciListesi"
                    class="aci-btn"
                    [class.aktif]="suankiAci === aci.key"
                    [title]="aci.aciklama"
                    (click)="aciDegistir(aci.key)">
                <i [class]="aci.ikon + ' icon'"></i>
            </button>
        </div>
    </div>

    <!-- Ayar Slider'ları -->
    <div class="slider-section">
        <div class="slider-row">
            <span class="slider-label">Hız</span>
            <input type="range" min="0" max="100" [(ngModel)]="kameraHizi">
            <span class="slider-value">{{kameraHizi}}%</span>
        </div>
        <div class="slider-row" *ngIf="dramatikZoom">
            <span class="slider-label">Zoom</span>
            <input type="range" min="0" max="100" [(ngModel)]="zoomSiddeti">
            <span class="slider-value">{{zoomSiddeti}}%</span>
        </div>
    </div>

    <!-- Toggle'lar -->
    <div class="toggle-row">
        <label class="toggle-item" title="Kesim/Rapid anında otomatik açı değiştir">
            <input type="checkbox" [(ngModel)]="otomatikAciDegisimi">
            <span>Oto Açı</span>
        </label>
        <label class="toggle-item" title="Kesim anında dramatik zoom">
            <input type="checkbox" [(ngModel)]="dramatikZoom">
            <span>D.Zoom</span>
        </label>
        <label class="toggle-item serbest-toggle" title="Serbest kamera - manuel zoom/pan yapabilirsin">
            <input type="checkbox" [(ngModel)]="serbestKamera">
            <span>Serbest</span>
        </label>
    </div>

    <div class="ui divider" style="margin:4px 0;"></div>

    <!-- Müzik Kontrolü -->
    <div class="section-row">
        <div class="section-label" style="color:#0cf;">MÜZİK</div>
        <input type="file" #muzikInput accept="audio/*" style="display:none" (change)="muzikDosyaYuklendi($event)">

        <div class="muzik-kontrol" *ngIf="!muzikYuklendi">
            <button class="ui icon mini button" (click)="muzikSec()" title="Müzik Yükle">
                <i class="upload icon"></i>
            </button>
        </div>

        <div class="muzik-player" *ngIf="muzikYuklendi">
            <button class="ui icon mini button" (click)="muzikOynatiliyor ? muzikDuraklat() : muzikOynat()">
                <i [class]="muzikOynatiliyor ? 'pause icon' : 'play icon'"></i>
            </button>
            <div class="muzik-progress">
                <div class="muzik-bar" [style.width.%]="muzikSure > 0 ? (muzikPozisyon / muzikSure) * 100 : 0"></div>
            </div>
            <span class="muzik-sure">{{sureFormatla(muzikPozisyon)}}</span>
        </div>
    </div>

    <!-- Müzik Ses Slider (yüklenince görünür) -->
    <div class="slider-row" *ngIf="muzikYuklendi">
        <span class="slider-label" style="color:#0cf;">Ses</span>
        <input type="range" min="0" max="100" [ngModel]="muzikSes" (ngModelChange)="muzikSesAyarla($event)">
        <span class="slider-value" style="color:#0cf;">{{muzikSes}}%</span>
    </div>

    <!-- Ritim Senkron Kontrolü (müzik yüklenince görünür) -->
    <div class="toggle-row" *ngIf="muzikYuklendi">
        <label class="toggle-item ritim-toggle" title="Müzik ritmine göre kamera efektleri">
            <input type="checkbox" [(ngModel)]="ritimSenkron">
            <span style="color:#0cf;">Ritim</span>
        </label>
    </div>

    <!-- Ritim Şiddeti Slider (ritim açıkken görünür) -->
    <div class="slider-row" *ngIf="muzikYuklendi && ritimSenkron">
        <span class="slider-label" style="color:#0cf;">Beat</span>
        <input type="range" min="0" max="100" [(ngModel)]="ritimSiddeti">
        <span class="slider-value" style="color:#0cf;">{{ritimSiddeti}}%</span>
    </div>

    <!-- Beat Enerji Göstergesi (ritim açık veya beat modunda, müzik oynatılıyorken) -->
    <!-- Beat Enerji Göstergesi (müzik veya demo beat aktifken) -->
    <div class="beat-indicator" *ngIf="(muzikYuklendi && (ritimSenkron || suankiAci === 'beat') && muzikOynatiliyor) || (demoBeat && suankiAci === 'beat')">
        <div class="beat-bar" [style.width.%]="anlikBeatEnerji * 100" [style.opacity]="0.5 + anlikBeatEnerji * 0.5"></div>
    </div>

    <!-- Beat Modu Ayarları (beat modu seçiliyken görünür) -->
    <div class="beat-ayarlar" *ngIf="suankiAci === 'beat'">
        <div class="section-row">
            <div class="section-label" style="color:#0ff;">BEAT</div>
            <!-- Hareket Tipi Seçici -->
            <select class="hareket-select" [(ngModel)]="beatHareketTipi" title="Hareket stili">
                <option value="smooth">Smooth</option>
                <option value="aggressive">Aggressive</option>
                <option value="pulse">Pulse</option>
            </select>
        </div>

        <!-- Toggle'lar - Satır 1 -->
        <div class="toggle-row">
            <label class="toggle-item beat-toggle" title="Takımı takip et">
                <input type="checkbox" [(ngModel)]="beatTakimTakip">
                <span>Takım</span>
            </label>
            <label class="toggle-item beat-toggle" title="Beat'te açı atla">
                <input type="checkbox" [(ngModel)]="beatAciAtlama">
                <span>Atla</span>
            </label>
            <!-- Orbit Yönü -->
            <button class="yon-btn" [class.ters]="beatOrbitYonu === -1"
                    (click)="beatOrbitYonu = beatOrbitYonu * -1"
                    title="Orbit yönünü değiştir">
                <i [class]="beatOrbitYonu === 1 ? 'redo icon' : 'undo icon'"></i>
            </button>
        </div>

        <!-- Toggle'lar - Satır 2: Sabit Kamera & Demo Beat -->
        <div class="toggle-row">
            <label class="toggle-item sabit-kamera-toggle" title="Sabit kamera - sadece zoom efekti, hareket yok">
                <input type="checkbox" [(ngModel)]="beatSabitKamera">
                <span>Sabit</span>
            </label>
            <label class="toggle-item takim-izle-toggle" *ngIf="beatSabitKamera" title="Sabit modda takımı izle">
                <input type="checkbox" [(ngModel)]="beatSabitTakimIzle">
                <span>Takım İzle</span>
            </label>
            <label class="toggle-item demo-beat-toggle" *ngIf="!muzikOynatiliyor" title="Demo beat - müzik yokken test için simüle beat">
                <input type="checkbox" [(ngModel)]="demoBeat">
                <span>Demo</span>
            </label>
        </div>

        <!-- Slider'lar -->
        <div class="slider-row">
            <span class="slider-label" style="color:#0ff;">Orbit</span>
            <input type="range" min="0" max="100" [(ngModel)]="beatOrbitHizi" class="beat-slider">
            <span class="slider-value" style="color:#0ff;">{{beatOrbitHizi}}%</span>
        </div>
        <div class="slider-row">
            <span class="slider-label" style="color:#0ff;">Zoom</span>
            <input type="range" min="0" max="100" [(ngModel)]="beatZoomEfekti" class="beat-slider">
            <span class="slider-value" style="color:#0ff;">{{beatZoomEfekti}}%</span>
        </div>
        <div class="slider-row">
            <span class="slider-label" style="color:#0ff;">Shake</span>
            <input type="range" min="0" max="100" [(ngModel)]="beatShakeEfekti" class="beat-slider">
            <span class="slider-value" style="color:#0ff;">{{beatShakeEfekti}}%</span>
        </div>
    </div>

    <div class="ui divider" style="margin:4px 0;"></div>

    <!-- Kayıt Ayarları -->
    <div class="section-row">
        <div class="section-label" style="color:#f36;">KAYIT</div>
        <select class="kalite-select" [(ngModel)]="kayitKalitesi">
            <option [value]="1500000">720p</option>
            <option [value]="2500000">1080p</option>
            <option [value]="5000000">1080p+</option>
            <option [value]="8000000">4K</option>
        </select>
    </div>

    <!-- Müzik Dosya Adı -->
    <div class="muzik-info" *ngIf="muzikYuklendi">
        <i class="music icon"></i>
        <span class="muzik-isim">{{muzikIsim}}</span>
    </div>

    <!-- Beat Modu Uyarısı -->
    <div class="beat-uyari" *ngIf="suankiAci === 'beat' && (!muzikYuklendi || !muzikOynatiliyor)">
        <i class="exclamation triangle icon"></i>
        <span>Beat modu için müzik yükle ve oynat</span>
    </div>

    <div class="ui divider" style="margin:4px 0;"></div>

    <!-- Gelişmiş Ayarlar Toggle -->
    <div class="section-row gelismis-header" (click)="gelismisAyarlarAcik = !gelismisAyarlarAcik">
        <div class="section-label" style="color:#a8f;">GELİŞMİŞ</div>
        <button class="toggle-expand-btn" [class.acik]="gelismisAyarlarAcik">
            <i [class]="gelismisAyarlarAcik ? 'chevron up icon' : 'chevron down icon'"></i>
        </button>
    </div>

    <!-- Gelişmiş Ayarlar Paneli -->
    <div class="gelismis-panel" *ngIf="gelismisAyarlarAcik">

        <!-- Beat Algılama Ayarları -->
        <div class="ayar-grup">
            <div class="ayar-baslik">Beat Algılama</div>
            <div class="slider-row">
                <span class="slider-label" style="color:#a8f;">Hassas</span>
                <input type="range" min="20" max="100" [(ngModel)]="beatHassasiyet" class="gelismis-slider">
                <span class="slider-value" style="color:#a8f;">{{beatHassasiyet}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#a8f;">Cooldown</span>
                <input type="range" min="50" max="500" step="10" [(ngModel)]="beatCooldownAyar" class="gelismis-slider">
                <span class="slider-value" style="color:#a8f;">{{beatCooldownAyar}}ms</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#a8f;">Bass</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatBassAgirlik" class="gelismis-slider">
                <span class="slider-value" style="color:#a8f;">{{beatBassAgirlik}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#a8f;">Mid</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatMidAgirlik" class="gelismis-slider">
                <span class="slider-value" style="color:#a8f;">{{beatMidAgirlik}}%</span>
            </div>
        </div>

        <!-- Beat Tepki Şiddetleri (Ritme göre ne kadar etki edecek) -->
        <div class="ayar-grup">
            <div class="ayar-baslik">Beat Tepki Şiddetleri</div>
            <div class="slider-row">
                <span class="slider-label" style="color:#0ff;">Zoom</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatZoomTepki" class="gelismis-slider tepki-slider" title="Beat'te zoom in şiddeti">
                <span class="slider-value" style="color:#0ff;">{{beatZoomTepki}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#0ff;">Orbit</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatOrbitTepki" class="gelismis-slider tepki-slider" title="Beat'te orbit hız artışı">
                <span class="slider-value" style="color:#0ff;">{{beatOrbitTepki}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#0ff;">Mesafe</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatMesafeTepki" class="gelismis-slider tepki-slider" title="Beat'te kamera yaklaşma şiddeti">
                <span class="slider-value" style="color:#0ff;">{{beatMesafeTepki}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#0ff;">Yüks.</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatYukseklikTepki" class="gelismis-slider tepki-slider" title="Beat'te kamera yükselme şiddeti">
                <span class="slider-value" style="color:#0ff;">{{beatYukseklikTepki}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#0ff;">Shake</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatShakeTepki" class="gelismis-slider tepki-slider" title="Beat'te kamera sarsıntı şiddeti">
                <span class="slider-value" style="color:#0ff;">{{beatShakeTepki}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#0ff;">Target</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatTargetTepki" class="gelismis-slider tepki-slider" title="Beat'te bakış noktası salınım şiddeti">
                <span class="slider-value" style="color:#0ff;">{{beatTargetTepki}}%</span>
            </div>
        </div>

        <!-- Genel Tepki Ayarları -->
        <div class="ayar-grup">
            <div class="ayar-baslik">Genel Ayarlar</div>
            <div class="slider-row">
                <span class="slider-label" style="color:#f8a;">Hız</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatTepkiHizi" class="gelismis-slider genel-slider" title="Tepkilerin uygulanma hızı">
                <span class="slider-value" style="color:#f8a;">{{beatTepkiHizi}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#f8a;">Enerji</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatEnerjiCarpani" class="gelismis-slider genel-slider" title="Güçlü beat'lere daha fazla tepki">
                <span class="slider-value" style="color:#f8a;">{{beatEnerjiCarpani}}%</span>
            </div>
            <div class="slider-row">
                <span class="slider-label" style="color:#f8a;">Geri Dön</span>
                <input type="range" min="0" max="100" [(ngModel)]="beatZoomGeriDonus" class="gelismis-slider genel-slider" title="Zoom'un normale dönüş hızı">
                <span class="slider-value" style="color:#f8a;">{{beatZoomGeriDonus}}%</span>
            </div>
        </div>

    </div>

    <!-- Alt Bilgi -->
    <div class="alt-bilgi">
        <span *ngIf="aktif && suankiAci === 'beat' && muzikOynatiliyor" class="beat-badge">
            <i class="music icon"></i> Beat Aktif
        </span>
        <span *ngIf="aktif && suankiAci !== 'beat'" class="aktif-badge">
            <i class="film icon"></i> Director Aktif
        </span>
        <span *ngIf="kayitYapiliyor" class="kayit-badge">
            HD {{kayitKalitesi >= 5000000 ? '4K' : kayitKalitesi >= 2500000 ? '1080p' : '720p'}} WebM
        </span>
    </div>
</div>
